import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import commonFn from '@/commons/commonFunction';
class OptionApi extends BaseAPI {
  controllerName = 'Options';
  apiName = "TaskGo";
  /**
   * Lấy dữ liệu danh sách
   */
  async getDbOptions(key) {
    let request = {
      url: this.getAPIUrl() + '/' + key,
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Cập nhật dbOption
   * @param {*} payload 
   * @returns 
   */
  async updateDbOptions(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Get LocationTax
   * @returns 
   */
  async locationTax(payload) {

    let request = {
      url: this.getAPIUrl() + '/LocationTax',
      data: payload
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Get OptionName
   * @returns 
   */
  async optionName(payload) {

    let request = {
      url: this.getAPIUrl() + '/OptionName',
      data: payload
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Get dữ liệu autoId
   * @returns 
   */
  async autoId() {

    let apiUrl = window._apis[this.apiName] + '/' + 'AutoIds';

    let request = {
      url: apiUrl + '/autoid',
      data: {
        Skip: 0,
        Take: 100,
        Sort: "ref_type_category_id",
        Columns: "ref_type_category_id,ref_type_category_name,prefix,value,length_of_value,suffix",
        type: 0
      }
    };

    return await httpClient.postAsync(request);
  }

  /**
   * save dữ liệu autoId
   * @returns 
   */
  async saveAutoId(payload) {

    let apiUrl = window._apis[this.apiName] + '/' + 'AutoIds';

    let request = {
      url: apiUrl + '/save',
      data: payload
    };

    return await httpClient.postAsync(request);
  }

  /**
   * check phát sinh ghi sổ vật tư hàng hóa
   * @returns 
   */
  async checkInventoryLedger() {

    let apiUrl = this.getAPIUrl() + '/CheckInventoryLedger';

    let request = {
      url: apiUrl,
    };

    return await httpClient.postAsync(request);
  }

  /**
 * Lấy dữ liệu thiết lập thoonng báo
 */
  async getNotificationSetting() {
    let request = {
      url: [this.getAPIUrl(), "GetNotificationSetting"].join("/"),
    };
    return await httpClient.postAsync(request);
  }

  /**
* Lấy dữ liệu thiết lập thông báomặc định
*/
  async getNotificationSettingDefault() {
    let request = {
      url: [this.getAPIUrl(), "GetNotificationSettingDefault"].join("/"),
    };
    return await httpClient.postAsync(request);
  }

    /**
* Lấy dữ liệu thiết lập thông báomặc định
*/
async GetSettingNotificationFilter() {
  let request = {
    url: [this.getAPIUrl(), "GetSettingNotificationFilter"].join("/"),
    transformResponse: (res) => {
      return res;
    },
  };
  return await httpClient.postAsync(request);
}

}

export default new OptionApi();
